import React from 'react';
import { Edit, SimpleForm, TextInput, SelectInput, DateInput, ShowButton, required, ReferenceField } from 'react-admin';
import CustomTextField from '../components/CustomTextField';
import RichTextInput from 'ra-input-rich-text';
import ISConfig from '../config';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import SystemsIcon from '@material-ui/icons/Tune';
import CustomLabelInput from '../components/CustomLabelInput';

const SystemEditActions = props => {
    const { basePath } = props;
    return (
        <CardActions {...props} >
            <BackButton style={{ marginRight: "auto" }} />
            <ShowButton basePath={basePath} record={props.data} />
        </CardActions>
    );
}

const SystemEditGeneral = ({ record }) => {
    var SystemStatusSelectChoices = [];
    ISConfig.statuses.system.forEach(element => { SystemStatusSelectChoices.push({ id: element, name: element }) });
    var SystemTypeSelectChoicesRequired = [];
    for (const key in ISConfig.system_types) { SystemTypeSelectChoicesRequired.push({ id: ISConfig.system_types[key].label, name: ISConfig.system_types[key].label }) }

    return (
        <div className="row mb-3 mb-md-0">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row">
                    <div className="col-4 col-xs-2 col-sm-4 col-md-3">
                        <TextInput source="code" validate={required()} label={<CustomLabelInput label="Code" />} variant="outlined" fullWidth />
                    </div>
                    <div className="col-8 col-xs-6 col-sm-6 col-md-5">
                        <TextInput source="name" validate={required()} label={<CustomLabelInput label="Name" />} variant="outlined" fullWidth />
                    </div>
                    <div className="col">
                        <SelectInput source="status" validate={required()} choices={SystemStatusSelectChoices} label={<CustomLabelInput label="Status" />} variant="outlined" fullWidth />
                    </div>
                    <div className="col-12">
                        <SelectInput source="type" validate={required()} choices={SystemTypeSelectChoicesRequired} label={<CustomLabelInput label="Type" />} variant="outlined" fullWidth />
                    </div>
                    <div className="col-12 mb-2">
                        <div>
                            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Location</h6>
                            <ReferenceField style={{ margin: '0px' }} label="" source="location_id" resource="locations" reference="locations" link="show"><CustomTextField className="m-0 p-0" source="name" /></ReferenceField>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 px-4 pt-1">
                <SystemEditNotes record={record} />
            </div>
        </div>
    );
};

const SystemEditNotes = ({ record }) => {
    return (
        <div className="row">
            <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                <RichTextInput source="notes" label="Notes" stripTags emptyText="Notes" />
            </div>
        </div>
    );
};

const SystemEditElements = props => {
    const { elements } = props.record;
    var elementskey = []
    for (const key in elements) {
        var elementskeycontent = [];
        var inspections = elements[key].inspections;
        for (const keyins in inspections) {
            elementskeycontent.push(
                <li id={keyins.charAt(0) + keyins.slice(1).replace('_', '') + '-li'} className="list-group-item">
                    <h6 className="fw-light text-secondary">{ISConfig.frequencies[keyins].label}</h6>
                    <div className="row m-0 d-flex justify-content-around">
                        <DateInput className="col mx-2" label={<CustomLabelInput label="Last Inspection" />} source={`elements.${key}.inspections.${keyins}.last_inspection`} variant="outlined" />
                        <DateInput className="col mx-2" label={<CustomLabelInput label="Valid Until" />} source={`elements.${key}.inspections.${keyins}.valid_until`} variant="outlined" />
                    </div>
                </li>
            )
        }

        var elementskeycontentordered = [];
        ISConfig.frequencies_order.forEach(element => { elementskeycontentordered.push(elementskeycontent.filter(e => e.props.id == element + '-li')[0]) });
        elementskey.push(<ul className="list-group my-3" id={key.charAt(0) + key.slice(1).replace('_', '') + '-ul'}>
            <li class="list-group-item active text-dark fw-bold" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">{key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ')}</li>
            {elementskeycontentordered}
        </ul>
        );
    }

    return (
        <div>
            <div>
                {elementskey.filter(element => element.props.id == 'main-ul')[0]}
                {elementskey.filter(element => element.props.id == 'antifreeze-ul')[0]}
                {elementskey.filter(element => element.props.id == 'firepump-ul')[0]}
                {elementskey.filter(element => element.props.id == 'trip-ul')[0]}
            </div>
        </div>
    );
};

const SystemEdit = (props) => {
    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Edit System</h3>
            <Edit className="m-0 p-0" title=" " actions={<SystemEditActions />}  {...props}>
                <SimpleForm redirect="show">
                    <SystemEditGeneral className="mb-3" record={{ ...props }} />

                    <h6 className="font-weight-normal pt-2">{<SystemsIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Systems</h6>
                    <SystemEditElements className="mb-3 mt-0 pt-0" {...props} />
                </SimpleForm>
            </Edit>
        </>
    )
};

export default SystemEdit;